import TableSearch from "@/components/table_search/TableSearch";
import Header from "../_components/Header";
import PaginationEl from "../_components/PaginationEl";
import { useState } from "react";
import { useDebounce } from "@/hooks/useCustomDebounce";
import { useQuery } from "@tanstack/react-query";
import api from "@/context/apiRequest";
import { adminUsersBreadcrumbList } from "@/l-data/admin/breadcrumLists";
import ApiError from "@/components/error404/ApiError";
import TableSkeleton from "@/components/skeletons/TableSkeleton";
import AddElement from "../_components/AddElement";
import UsersTable from "./_components/UsersTable";
import AddNewUserForm from "./_components/AddNewUserForm";

export default function AdminUsers() {
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState("");
  const debouncedSearch = useDebounce(search, 1000);
  const [open, setOpen] = useState<boolean>(false);

  const {
    data: adminUsers,
    isLoading,
    isError,
  } = useQuery({
    queryKey: ["admin-users", debouncedSearch, page],
    queryFn: async () =>
      await api()
        .get(`/api/v1/admin/users?search=${search}&page=${search ? 1 : page}`)
        .then((res) => {
          return res?.data?.data;
        }),
  });

  return (
    <main>
      <Header title={"Users Display"} list={adminUsersBreadcrumbList} />
      <div className="flex items-center justify-between py-6">
        <TableSearch search={search} setSearch={setSearch} />
        <AddElement
          open={open}
          setOpen={setOpen}
          title="Add New User"
          subtitle="Fill all required inputs to add new user"
          formEl={<AddNewUserForm setOpen={setOpen} />}
        />
      </div>
      {adminUsers && <UsersTable data={adminUsers} />}
      {adminUsers && <PaginationEl setPage={setPage} data={adminUsers} />}
      {isLoading && <TableSkeleton />}
      {isError && <ApiError />}
    </main>
  );
}
